// extracted by mini-css-extract-plugin
export default {"appHeader":"styles_appHeader__zrySy","timer":"styles_timer__muDAI","submit":"styles_submit__TJK7Q","pulsing-button":"styles_pulsing-button__g459r"};